// @ts-nocheck
import React from "react";
import { Information24, currencyFormatter } from "@sia/style-guide";
import { fetchCompanyDetail, fetchNogaDetail } from "./dataFetching";
function extractActiveFilters(overheadFilters, filterId, isInitialLoad) {
  const DEFAULT_ITEMS = [];
  let filter = overheadFilters.filters.find((e) => e.id === filterId);
  if (isInitialLoad) {
    return DEFAULT_ITEMS;
  }
  if (filter) {
    let items = filter.items.filter((e) => e.active).map((e) => e.id);
    return items;
  }
  return DEFAULT_ITEMS;
}

export function extractRequestBodyFromFilters(overheadFilters, isInitialLoad) {
  let years = extractActiveFilters(overheadFilters, "surveyYears", isInitialLoad);
  const nogaCodes = extractActiveFilters(overheadFilters, "nogaCode", isInitialLoad);
  const officeSizeIds = extractActiveFilters(overheadFilters, "officeSize", isInitialLoad);
  const greaterRegions = extractActiveFilters(overheadFilters, "greaterRegion", isInitialLoad);

  let body = {
    years,
    nogaCodes,
    officeSizeIds,
    greaterRegions,
  };

  return body;
}

async function setInitialActiveNoga(filtersCopy, languageKey, nogaFilterIndex, companyAccess) {
  let onError = (err) => console.log(err);
  let companyDetail = await fetchCompanyDetail(onError, companyAccess);
  let { nogaId } = companyDetail.data[0];
  let nogaDetails = await fetchNogaDetail(languageKey, nogaId, onError);
  let { nogaCode } = nogaDetails.data;
  if (nogaFilterIndex !== -1) {
    filtersCopy.filters[nogaFilterIndex].items = filtersCopy.filters[nogaFilterIndex].items.map((option) => ({
      ...option,
      active: option.id === nogaCode,
    }));
    const noActiveNogas = filtersCopy.filters[nogaFilterIndex].items.every((item) => !item.active);
    // If the company doesn't have noga
    // Activate The Archi office as default selected noga
    if (noActiveNogas) {
      activateDefaultNogaCode(filtersCopy, nogaFilterIndex);
    }
  }
  return filtersCopy;
}

function setInitialActiveSurveyYear(filtersCopy) {
  let surveyYearsFilterIndex = filtersCopy.filters.findIndex((e) => e.id === "surveyYears");
  let currentYear = new Date().getFullYear();
  filtersCopy.filters[surveyYearsFilterIndex].items = filtersCopy.filters[surveyYearsFilterIndex].items
    .filter((e) => e.id === currentYear)
    .map((e) => ({ ...e, active: true }));
  return filtersCopy;
}

function activateDefaultNogaCode(filtersCopy, nogaFilterIndex) {
  const ARCHI_OFFICE_NOGA_CODE = 711101;
  filtersCopy.filters[nogaFilterIndex].items = filtersCopy.filters[nogaFilterIndex].items.map((option) => ({
    ...option,
    active: option.id === ARCHI_OFFICE_NOGA_CODE,
  }));
  return filtersCopy;
}

function updateFilterItems(filtersCopy, filter, submitedFilters, nextAvailableFilters) {
  let updatedFilterItems =
    filtersCopy.allAvailabeFilters[filter.id]?.map((item) => {
      let dropDownOption = {};
      if (filter.id === "surveyYears") {
        dropDownOption = { id: item, label: item, active: submitedFilters[filter.id].includes(item) };
        return dropDownOption;
      }
      let filterIds = nextAvailableFilters[filter.id].map((e) => e.id);
      dropDownOption = {
        id: item.id,
        label: item.value,
        name: item.value,
        active: submitedFilters[filter.id].includes(item.id),
        disabled: !filterIds.includes(item.id),
      };
      return dropDownOption;
    }) || [];
  return updatedFilterItems;
}

export async function updateFilters(filters, submitedFilters, nextAvailableFilters, isInitialLoad, isMasterKeyValid, languageKey) {
  let filtersCopy = { ...filters };

  if (isInitialLoad) {
    filtersCopy.allAvailabeFilters = nextAvailableFilters;
  }

  filtersCopy.filters = filtersCopy.filters.map((filter) => {
    let filterCopy = { ...filter };
    if (filter.id !== "reference") {
      filterCopy.items = updateFilterItems(filtersCopy, filter, submitedFilters, nextAvailableFilters);
    }
    return filterCopy;
  });
  let nogaFilterIndex = filtersCopy.filters.findIndex((e) => e.id === "nogaCode");
  if (isInitialLoad && isMasterKeyValid) {
    filtersCopy = await setInitialActiveNoga(filtersCopy, languageKey, nogaFilterIndex, isMasterKeyValid);
    filtersCopy = setInitialActiveSurveyYear(filtersCopy);
    return { ...filtersCopy, newest: true, isInitialLoad: false };
  } else if (isInitialLoad && !isMasterKeyValid) {
    filtersCopy = activateDefaultNogaCode(filtersCopy, nogaFilterIndex);
    filtersCopy = setInitialActiveSurveyYear(filtersCopy);
    return { ...filtersCopy, newest: true, isInitialLoad: false };
  }

  return { ...filtersCopy, newest: false, isInitialLoad: false };
}

export function getKeyFiguresPageQuality(data) {
  const keyFigures = data?.businessKeyFigures?.[0]?.keyFigures ?? [];

  const qualities = keyFigures.map((item) => item?.metrics?.quality).filter((q) => q && q.count != null && q.coefficientOfVariation != null);

  if (qualities.length === 0) {
    return null;
  }

  const count = qualities[0].count;

  const worstQuality = qualities.reduce((worst, current) => {
    const worstCv = Math.abs(worst?.coefficientOfVariation ?? 0);
    const currentCv = Math.abs(current?.coefficientOfVariation ?? 0);
    return currentCv > worstCv ? current : worst;
  });

  return {
    count,
    coefficientOfVariation: worstQuality.coefficientOfVariation,
  };
}

export function companyHasOwnValues(data) {
  let keyFigures = data.businessKeyFigures[0].keyFigures;
  const propertyName = "companyValue";
  let result = keyFigures[0].hasOwnProperty(propertyName);
  return result;
}

function formatAlternate(value) {
  let formatNumber = currencyFormatter.formatAlternate(value);
  return "CHF " + formatNumber;
}

function formatNumber(num, precision, suffex) {
  if (!num) {
    return "";
  }
  let formatedNumber = Number.parseFloat(num.toFixed(precision));
  if (suffex) {
    formatedNumber = `${formatedNumber} ${suffex}`;
    return formatedNumber;
  }
  return formatedNumber;
}

export function parseBarchartData(data, start, end, translate, hasOwnValues) {
  let keyFigures = data.businessKeyFigures[0].keyFigures;
  let keyFiguresSlice = keyFigures.slice(start, end || keyFigures.length);
  let parsedData = keyFiguresSlice.map((keyFigure) => {
    let averageObject = {
      key: keyFigure.figureName,
      value: formatNumber(keyFigure.metrics.mean, 2),
      group: translate("benchmarking.evaluations.salary.chart-legend.average"),
    };
    let data = [averageObject];

    if (hasOwnValues) {
      let myValueObject = {
        key: keyFigure.figureName,
        value: keyFigure.companyValue ? formatNumber(keyFigure.companyValue, 2) : 0,
        group: translate("benchmarking.evaluations.salary.chart-legend.my-office"),
      };
      data.push(myValueObject);
    }
    return data;
  });
  return parsedData.flat().reverse();
}

function generateTableCellCore(value) {
  let core = (
    <div className="table-cell-outer">
      <div className="table-cell-inner">{value}</div>
    </div>
  );
  return core;
}

function onClickCallback(index, title, setAlertState) {
  setAlertState((previousSate) => ({ ...previousSate, heading: title, index: index, open: true }));
}

export function parseTableData(data, hasOwnValues, setAlertState) {
  let keyFigures = [...data.businessKeyFigures[0].keyFigures];
  let currencyRowIndcies = [0, 1, 2];
  let extraClasses = !hasOwnValues ? " without-own-value" : "";
  let parsedData = keyFigures.map((keyFigure, index) => {
    let row = { cells: [], onRowClick: () => null };

    let firstCell = {
      value: generateTableCellCore(keyFigure.figureName),
      className: "left-align",
      key: 0,
    };
    let secondCellContent = currencyRowIndcies.includes(index)
      ? formatAlternate(keyFigure.metrics.mean)
      : formatNumber(keyFigure.metrics.mean, 1, "%");
    let secondCell = {
      value: generateTableCellCore(secondCellContent),
      className: "center-align".concat(extraClasses),
      key: 1,
    };
    row.cells.push(firstCell, secondCell);
    if (hasOwnValues) {
      let thirdCellContent = currencyRowIndcies.includes(index)
        ? formatAlternate(keyFigure.companyValue)
        : formatNumber(keyFigure.companyValue, 1, "%");
      let thirdCell = {
        value: generateTableCellCore(thirdCellContent),
        className: "center-align pink-bg",
        key: 2,
      };
      let foruthCellContent = currencyRowIndcies.includes(index) ? formatAlternate(keyFigure.deviation) : formatNumber(keyFigure.deviation, 1, "%");
      let fourthCell = {
        value: generateTableCellCore(foruthCellContent),
        className: "center-align",
        key: 3,
      };
      row.cells.push(thirdCell, fourthCell);
    }
    let iconCell = {
      value: <Information24 onClick={() => onClickCallback(index, keyFigure.figureName, setAlertState)} />,
      className: "icon-cell",
      key: 4,
    };
    row.cells.push(iconCell);
    return row;
  });
  return parsedData;
}
